/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { ClaimType } from '@constants';
import { SplitLine } from '../common';
import { Merchandise } from '../merchandise';
import { Panel } from '../panel';
import classes from './index.module.css';
import { RemarkPanel } from '../choose/remark-panel';

const ClaimTypeText = {
  [ClaimType.Delay]: 'My package was delayed',
  [ClaimType.Damage]: 'My item(s) was damaged',
  [ClaimType.Loss]: 'My item(s) was lost',
  [ClaimType.RA]: 'I want to return the item(s)',
};

const PackageItem = ({
  orderName, packageItem, index, reasonList,
}) => {
  if (!packageItem) {
    return null;
  }
  const { items, attachments } = packageItem || {};

  return (
    <section>
      {index !== 0 ? <SplitLine /> : null}
      <section className={classes.package_item}>
        <span className={classes.order_name_title}>Order</span>
        {orderName}
      </section>
      {items?.map((item, itemIndex) => {
        const files = attachments || item.attachments;
        const comment = packageItem.comment || item.comment;
        const reason = packageItem.reason || item.reason;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <section key={`${item.lineItemId}_${itemIndex}`}>
            {itemIndex === 0 ? null : <SplitLine />}
            <Merchandise item={item} className={classes.ra_merchandise} />
            {reason
              && (
                <RemarkPanel
                  title={reasonList ? reasonList?.find((v) => v.value === reason)?.label : reason}
                  files={files?.map((item) => item.originalFileName)}
                  additional={(comment)}
                />
              )}
          </section>
        );
      })}
    </section>
  );
};

const FileList = ({ files }) => (
  <>
    <SplitLine />
    <section className={classes.reported_title_padding}>
      <span className={classes.title_bold}>Supporting documents:</span>
      <span>{files.map((file) => file.name).join('; ')}</span>
    </section>
  </>
);

export const ReviewItemList = ({
  selectedPackageList, type,
  files, comments,
  reasonList,
}) => (
  <Panel className={classes.panel}>
    <section>
      <span className={classes.title_bold}>Issue reported:</span>
      <span>{ClaimTypeText[type]}</span>
    </section>
    {selectedPackageList?.map((packageItem, index) => (
      <PackageItem
        // eslint-disable-next-line react/no-array-index-key
        key={`${packageItem.fulfillmentName}_${index}`}
        packageItem={packageItem}
        index={index}
        orderName={packageItem.fulfillmentName}
        reasonList={reasonList}
        type={type}
      />
    ))}
    {files?.length ? <FileList files={files} /> : null}
    {comments && (
      <div className={classes.comments}>
        <span className={classes.title_bold}>Additional comments:</span>
        <span className={classes.comment_text}>{comments}</span>
      </div>
    )}
  </Panel>
);
